import React from 'react';
import styled from 'styled-components';
import SectionCard from './SectionCard';
import FieldDisplay from './FieldDisplay';
import { TextBlock } from 'bench-internal-theme';
import { colors } from 'bench-style-constants';
import { AlternateContactInfo } from '../types';

const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

const MilestonesContainer = styled.div`
  display: grid;
  gap: 8px;
`;

const MilestonesLabel = styled(TextBlock).attrs({
  styleType: 'small',
  color: colors.smoke,
  uppercase: true,
})``;

const MilestonesText = styled(TextBlock).attrs({
  styleType: 'medium',
  color: colors.charcoal,
})`
  padding: 12px;
  background-color: ${colors.pearl};
  border-radius: 4px;
  min-height: 60px;
`;

const ContactCard = styled.div`
  padding: 16px;
  border: 1px solid ${colors.silt};
  border-radius: 4px;
  display: grid;
  gap: 12px;
`;

const CardTitle = styled(TextBlock).attrs({
  styleType: 'mediumBold',
  color: colors.charcoal,
})``;

interface PreferencesSectionProps {
  milestones?: string;
  alternateContact?: AlternateContactInfo;
}

const PreferencesSection: React.FC<PreferencesSectionProps> = ({
  milestones,
  alternateContact,
}) => (
  <SectionCard title="Preferences">
    <MilestonesContainer>
      <MilestonesLabel>Important Milestones</MilestonesLabel>
      <MilestonesText>{milestones || 'No milestones listed'}</MilestonesText>
    </MilestonesContainer>

    <ContactCard>
      <CardTitle>Alternate Contact</CardTitle>
      {alternateContact ? (
        <FieldsGrid>
          <FieldDisplay label="Full Name" value={alternateContact.fullName} />
          <FieldDisplay label="Email" value={alternateContact.email} />
          <FieldDisplay label="Phone" value={alternateContact.phone} />
        </FieldsGrid>
      ) : (
        <TextBlock styleType="small" color={colors.cloud}>
          No alternate contact listed
        </TextBlock>
      )}
    </ContactCard>
  </SectionCard>
);

export default PreferencesSection;
